// ======================================================================
// 📁 File: src/modules/ppe/services/ppeExecutionService.js
// ======================================================================
// Purpose:
//   PPE Phase-5 Production Execution API client
//
//   Covers:
//   - List executable production plans
//   - View operations under a plan
//   - Release individual operations for execution
//
//   NOTE:
//   - This only triggers execution readiness
//   - No stock posting
//   - No WIP movement
//   - No MES execution
// ======================================================================

import axiosClient from "../../../api/axiosClient";

/**
 * ----------------------------------------------------------------------
 * PRODUCTION EXECUTION — PLANS
 * ----------------------------------------------------------------------
 */

/**
 * Get execution-eligible production plans
 *
 * Backend:
 * GET /api/ppe/execution/plans
 */
async function listExecutionPlans() {
  const res = await axiosClient.get(
    "/api/ppe/execution/plans"
  );

  return res.data.data || [];
}

/**
 * ----------------------------------------------------------------------
 * PRODUCTION EXECUTION — OPERATIONS
 * ----------------------------------------------------------------------
 */

/**
 * Get operations under a production plan
 *
 * Backend:
 * GET /api/ppe/execution/plans/:planId/operations
 */
async function listPlanOperations(planId) {
  const res = await axiosClient.get(
    `/api/ppe/execution/plans/${planId}/operations`
  );

  return res.data.data || [];
}

/**
 * ----------------------------------------------------------------------
 * OPERATION RELEASE
 * ----------------------------------------------------------------------
 */

/**
 * Release a single operation for execution
 *
 * Backend:
 * POST /api/ppe/execution/operations/:operationId/release
 *
 * Payload:
 * {
 *   production_plan_id,
 *   remarks
 * }
 */
async function releaseOperation(operationId, payload) {
  const res = await axiosClient.post(
    `/api/ppe/execution/operations/${operationId}/release`,
    payload
  );

  return res.data;
}

/**
 * ----------------------------------------------------------------------
 * EXPORT
 * ----------------------------------------------------------------------
 */

const ppeExecutionService = {
  // Execution plans
  listExecutionPlans,

  // Operations
  listPlanOperations,

  // Release
  releaseOperation,
};

export default ppeExecutionService;
